import { Module } from 'vuex'
import { RootState } from '../types'

interface LoaderState {
	isUploading: boolean
	progress: number
	error: string | null
	uploadTimeout: number | null
	uploadStartTime: number | null
	isLoading: boolean
	message: string
}

const loaderModule: Module<LoaderState, RootState> = {
	namespaced: true,

	state: {
		isUploading: false,
		progress: 0,
		error: null,
		uploadTimeout: null,
		uploadStartTime: null,
		isLoading: false,
		message: 'Cargando...'
	},

	getters: {
		isUploading: (state: LoaderState) => state.isUploading,
		progress: (state: LoaderState) => state.progress,
		error: (state: LoaderState) => state.error,
		uploadTimeout: (state: LoaderState) => state.uploadTimeout,
		uploadStartTime: (state: LoaderState) => state.uploadStartTime,
		isLoading: (state: LoaderState) => state.isLoading,
		message: (state: LoaderState) => state.message
	},

	mutations: {
		SET_UPLOADING(state: LoaderState, value: boolean) {
			state.isUploading = value
			if (!value) {
				state.progress = 0
				state.error = null
				if (state.uploadTimeout) {
					clearTimeout(state.uploadTimeout)
					state.uploadTimeout = null
				}
				state.uploadStartTime = null
			}
		},

		SET_PROGRESS(state: LoaderState, value: number) {
			state.progress = value
		},

		SET_ERROR(state: LoaderState, error: string | null) {
			state.error = error
			state.isUploading = false
			state.progress = 0
			if (state.uploadTimeout) {
				clearTimeout(state.uploadTimeout)
				state.uploadTimeout = null
			}
			state.uploadStartTime = null
		},

		SET_UPLOAD_TIMEOUT(state: LoaderState, timeoutId: number | null) {
			if (state.uploadTimeout) {
				clearTimeout(state.uploadTimeout)
			}
			state.uploadTimeout = timeoutId
		},

		SET_UPLOAD_START_TIME(state: LoaderState, time: number | null) {
			state.uploadStartTime = time
		},

		SET_LOADING(state: LoaderState, value: boolean) {
			state.isLoading = value
		},

		SET_MESSAGE(state: LoaderState, message: string) {
			state.message = message
		}
	},

	actions: {
		startUpload({ commit, state }: { commit: any; state: LoaderState }, { timeoutCallback, timeoutDuration = 60000 }: { timeoutCallback?: () => void; timeoutDuration?: number }) {
			commit('SET_UPLOADING', true)
			commit('SET_UPLOAD_START_TIME', Date.now())

			const timeoutId = window.setTimeout(() => {
				if (state.isUploading) {
					commit('SET_ERROR', 'La carga del archivo ha excedido el tiempo máximo permitido')
					if (timeoutCallback) timeoutCallback()
				}
			}, timeoutDuration)

			commit('SET_UPLOAD_TIMEOUT', timeoutId)
		},

		updateProgress({ commit }: { commit: any }, progress: number) {
			commit('SET_PROGRESS', progress)
		},

		setError({ commit }: { commit: any }, error: string) {
			commit('SET_ERROR', error)
		},

		finishUpload({ commit }: { commit: any }) {
			commit('SET_UPLOADING', false)
		},

		cancelUpload({ commit }: { commit: any }) {
			commit('SET_UPLOADING', false)
		},

		setLoading({ commit }: { commit: any }, { isLoading, message = 'Cargando...' }: { isLoading: boolean; message?: string }) {
			commit('SET_LOADING', isLoading)
			commit('SET_MESSAGE', message)
		}
	}
}

export default loaderModule
